import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';

const buildQuery = (
  metric: MetricInput,
  filterInput: FilterInput[],
  dateScope: DateRangeInput,
  groupBy?: V5GroupBy,
  trendByCalendarInterval?: FleetOps.Interval,
  trendByFixedIntervalDays?: number,
  trendByFiscalInterval?: FixedPeriods.FiscalType,
  groupByDayOfWeek?: boolean,
  groupByMonth?: boolean,
) => {
  return {
    query: gql`
      query aggregateMetric(
        $metric: MetricInput!
        $filters: [FilterInput]!
        $dateScope: [DateRangeInput!]!
        $groupBy: GroupBy
        $trendByCalendarInterval: Interval
        $trendByFiscalInterval: FiscalInterval
        $trendByFixedIntervalDays: Int
        $groupByDayOfWeek: Boolean
        $groupByMonth: Boolean
      ) {
        aggregateMetric(
          metric: $metric
          dateScope: $dateScope
          filters: $filters
          groupBy: $groupBy
          trendByCalendarInterval: $trendByCalendarInterval
          trendByFiscalInterval: $trendByFiscalInterval
          trendByFixedIntervalDays: $trendByFixedIntervalDays
          groupByDayOfWeek: $groupByDayOfWeek
          groupByMonth: $groupByMonth
        )
      }
    `,
    variables: {
      metric,
      filters: filterInput,
      dateScope,
      groupBy,
      trendByCalendarInterval,
      trendByFiscalInterval,
      trendByFixedIntervalDays,
      groupByDayOfWeek,
      groupByMonth,
    },
  };
};

const aggregateMetric = async (
  metric: MetricInput,
  filterInput: FilterInput[],
  dateScope: DateRangeInput,
  client: ApolloClient<NormalizedCacheObject>,
  groupBy?: V5GroupBy,
  trendByCalendarInterval?: FleetOps.Interval,
  trendByFixedIntervalDays?: number,
  trendByFiscalInterval?: FixedPeriods.FiscalType,
  groupByDayOfWeek?: boolean,
  groupByMonth?: boolean,
): Promise<MetricResponse[]> => {
  const query = buildQuery(
    metric,
    filterInput,
    dateScope,
    groupBy,
    trendByCalendarInterval,
    trendByFixedIntervalDays,
    trendByFiscalInterval,
    groupByDayOfWeek,
    groupByMonth,
  );
  const response = await client.query(query);
  return response.data.aggregateMetric;
};

export default aggregateMetric;
